// extracted by mini-css-extract-plugin
export var closeButton = "_m0-1";
export var closeX = "_m0-3";
export var container = "_m0-0";
export var image = "_m0-2";